import { useContext } from "react";
import { RedirectionContext } from "../context/redirection_provider";

export const useRedirection = ():any => {
  return useContext(RedirectionContext);
}